module.exports = __webpack_public_path__ + "static/media/IN_Payslip_2.39f351a0.png";